/***************************************************************
6/6/2017
Alexander Self
Accordion
- Displays timesheets and daily summaries as accordions
***************************************************************/
import TimesheetSummaryView from './timesheet_view_summary';
import TimesheetIndividualSummaryView from './timesheet_view_individual_summary';

import React from 'react';
const $ = window.$;


const Accordion = ({ id, timesheets, date }) => {
  if (timesheets.length === 0) return <div></div>;

  $(document).ready(() => {
    // Materialize Initialization
    $(`#${id}`).collapsible();
  });

  return (
    <ul id={id} className="collapsible popout" data-collapsible="accordion">
      <li>
        <div className="collapsible-header"><i className="material-icons">insert_chart</i><b>Summary</b>
          <span className="right-align"><b>{date}</b></span>
        </div>
        <div className="collapsible-body">
          <TimesheetSummaryView timesheets={timesheets} />
        </div>
      </li>
      {
        timesheets.map((ts) => (
          <li key={ts.eid}>
            <div className="collapsible-header">
              <i className="material-icons">perm_identity</i>
              <span className="left-align">{ ts.firstName } { ts.lastName }</span>
              <span className="right-align">{ ts.eid }</span>
            </div>
            <div className="collapsible-body">
              <TimesheetIndividualSummaryView ts={ts} />
            </div>
          </li>
        ))
      }
    </ul>
  );
};

export default Accordion;



// WEBPACK FOOTER //
// ./src/components/timesheets/view/timesheet_accordion.js